import React from 'react'
// import system from 'system-components'
import { iframeResizer } from 'iframe-resizer'
import 'typeface-lato'

import Layout from 'components/layout'
// import { Img } from 'components/ui'

export class IframeResize extends React.Component {
  static defaultProps = {
    scrolling: 'no',
    frameBorder: 0,
  }

  constructor(props) {
    super(props)
    this.iframe = React.createRef()
  }

  componentDidMount() {
    this.iframeResizer = iframeResizer(
      // FIXME: Remove this when in prod
      // {
      //   checkOrigin: false,
      // },
      this.iframe.current,
    )
    // window.iFrameResizer = iframeResizer
  }

  componentWillUnmount() {
    this.iframe.current.iFrameResizer.close()
  }

  // style={{
  //   overflow: 'hidden',
  //   height: 500,
  //   width: '100%',
  //
  //   width: '1px',
  //   minWidth: '100%',
  // }}

  render() {
    return (
      <iframe
        id={this.props.id}
        title={this.props.title}
        src={this.props.src}
        // allowFullScreen
        // frameBorder={this.props.frameBorder}
        scrolling={this.props.scrolling}
        ref={this.iframe}
        style={{
          height: '100vh',
          width: 1,
          minWidth: '100%',
        }}
      >
        {this.props.children}
      </iframe>
    )
  }
}

export const HireUs = () => (
  <Layout>
    <IframeResize
      id="hire-us"
      title="Hire Us Form"
      src="https://hub.madvoid.com/hire_us/opportunities/new?opportunity%5Bconversion_point%5D=Hire+Us+Page"
      // src="http://localhost:3000/hire_us/opportunities/new?opportunity%5Bconversion_point%5D=Hire+Us+Page"
      frameBorder="0"
    />
  </Layout>
)

export default HireUs
